module.exports = __webpack_public_path__ + "static/c7-8d540870295eb5510036176f9715aa73.jpg";